import Backbone from 'backbone'
import template from './progress-indicators-test.hbs'
import Slider from 'scoreboard/components/slider'
import $ from 'jquery'
import WizardProgress from 'scoreboard/components/wizard-progress'

var ProgressIndicatorsTestView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-progress-indicators',

	events: {
		'click .reset': 'resetAll'
	},

	render: function () {
		this.$el.empty().append(template())

		this.$('input[type=number]').each(function() {
			if ($(this).is('[data-movable]')) {
				new Slider({ input : this, movable: true}).render()
			} else {
				new Slider({ input : this}).render()
			}
		})

		var wizard1 = new WizardProgress({
			step: 4,
			steps: 6,
			lastNavigable: 6
		})
		this.$('.wizard-progress-test-one').append(wizard1.el)
		wizard1.render()

		function randomProgress() {
			return new WizardProgress({
				step: Math.floor(Math.random()*11),
				steps: 10,
				lastNavigable: 6
			})
		}

		// Example 2 (animations)
		var wizard2 = new WizardProgress({
			step: 4,
			steps: 10,
			lastNavigable: 6
		})

		this.$('.wizard-animation-test .wizard-example-controls').before(wizard2.render().el)
		this.$('.wizard-refresh').click(function() {
			wizard2 = randomProgress()
			this.$('.wizard-progress-test-two .wizard-progress').replaceWith(wizard2.render().el)
			this.$('.animations-text').css('color', '#00d600')
		}.bind(this))
		this.$('.wizard-refresh-no-animation').click(function() {
			wizard2 = randomProgress()
			wizard2.toggleAnimation(false)
			this.$('.wizard-progress-test-two .wizard-progress').replaceWith(wizard2.render().el)
			wizard2.toggleAnimation(true)
			this.$('.animations-text').css('color', '#00d600')
		}.bind(this))
		this.$('.wizard-back').click(function() {
			wizard2.back()
		}.bind(this))
		this.$('.wizard-forward').click(function() {
			wizard2.forward()
		}.bind(this))
		this.$('.wizard-remove').click(function() {
			wizard2.removeStep()
		}.bind(this))
		this.$('.wizard-add').click(function() {
			wizard2.addStep()
		}.bind(this))
		this.$('.wizard-animation-on').click(function() {
			wizard2.toggleAnimation(true)
			this.$('.animations-text').css('color', '#00d600')
		}.bind(this))
		this.$('.wizard-animation-off').click(function() {
			wizard2.toggleAnimation(false)
			this.$('.animations-text').css('color', '#f44336')
		}.bind(this))

		// Example 3 (setting values explicitely)
		var wizard3 = new WizardProgress({
			step: 4,
			steps: 6,
			lastNavigable: 6
		})
		this.$('.wizard-set-values-test .wizard-example-controls').before(wizard3.render().el)
		this.$('.wizard-set-values-test button').click(function(e) {
			wizard3.setValues({
				step: 4,
				steps: e.target.dataset.step
			})
		})

		// Example 4 (stepping multiple steps in one call)
		var wizard4 = new WizardProgress({
			step: 4,
			steps: 11,
			lastNavigable: 11
		})
		this.$('.wizard-set-steps-test .wizard-example-controls').before(wizard4.render().el)
		this.$('.wizard-set-steps-test button').click(function(e) {
			wizard4.setValues({
				step: e.target.dataset.step,
				steps: 11
			})
		})

		return this
	}

})

export default ProgressIndicatorsTestView
